document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", async function (event) {
      let button = event.target.closest(".quick-add"); // Detect button click
      if (!button) return; // Ignore clicks outside the button

      event.preventDefault(); // Prevent default form submission
      event.stopPropagation(); // Stop event bubbling



      let productId = button.getAttribute("data-product-id"); // Get product ID
      if (!productId) {
          console.error("Error: Product ID is missing.");
          return;
      }


      // Set button to loading state
      button.classList.add("loading");
      button.innerText = "Adding...";

      try {
          let response = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                  "Content-Type": "application/json"
              },
              body: JSON.stringify({
                  id: Number(productId), // Convert ID to number
                  quantity: 1
              })
          });


          let responseText = await response.text();


          if (!response.ok) {
              throw new Error("Failed to add to cart");
          }

          let data = JSON.parse(responseText);

          // Reset button state
          button.classList.remove("loading");
          button.innerText = "Added!";

          // Refresh after 1 second
          setTimeout(() => {
              location.reload();
          }, 1000);

      } catch (error) {
          console.error("Error adding to cart:", error);
          button.classList.remove("loading");
          button.innerText = "Add to Basket"; // Reset text on error
      }
  });
});
